import angular from 'angular';

import RowBuilderDirective from './row-builder.directive';

const RowBuilderModule = angular
    .module('control-room.commons.form.components.row-builder', [])
    .directive('crRowBuilder', RowBuilderDirective.directiveFactory);

export default RowBuilderModule;
